export const ANIMATABLE_VALUES = [
  'columnCount',
  'columnGap',
  'columnRule',
  'columnRuleColor',
  'columnRuleWidth',
  'columns',
  'flex',
  'flexBasis',
  'flexGrow',
  'flexShrink',
  'order',
  'perspective',
  'perspectiveOrigin',
  'perspectiveOriginX',
  'perspectiveOriginY',
  'scrollSnapCoordinate',
  'scrollSnapDirection',
  'textDecoration',
  'textDecorationColor',
  'transform',
  'transformOrigin',
  'transformOriginX',
  'transformOriginY',
  'transformOriginZ',
  'transformStyle',
];

export const CSS_PROPERTIES = [
  'alignContent',
  'alignItems',
  'alignSelf',
  'animation',
  'animationDelay',
  'animationDirection',
  'animationDuration',
  'animationFillMode',
  'animationIterationCount',
  'animationName',
  'animationPlayState',
  'animationTimingFunction',
  'appearance',
  'aspectRatio',
  'backfaceVisibility',
  'backgroundClip',
  'borderImage',
  'borderImageSlice',
  'boxShadow',
  'columnCount',
  'columnFill',
  'columnGap',
  'columnRule',
  'columnRuleColor',
  'columnRuleStyle',
  'columnRuleWidth',
  'columnSpan',
  'columnWidth',
  'columns',
  'flex',
  'flexBasis',
  'flexDirection',
  'flexFlow',
  'flexGrow',
  'flexShrink',
  'flexWrap',
  'fontFeatureSettings',
  'fontKearning',
  'fontVariantLigatures',
  'justifyContent',
  'grid',
  'gridArea',
  'gridAutoColumns',
  'gridAutoFlow',
  'gridAutoRows',
  'gridColumn',
  'gridColumnEnd',
  'gridColumnStart',
  'gridRow',
  'gridRowEnd',
  'gridRowStart',
  'gridTemplate',
  'gridTemplateAreas',
  'gridTemplateColumns',
  'gridTemplateRows',
  'hyphens',
  'lineBreak',
  'perspective',
  'perspectiveOrigin',
  'perspectiveOriginX',
  'perspectiveOriginY',
  'rubyPosition',
  'scrollSnapCoordinate',
  'scrollSnapDestination',
  'scrollSnapPoints',
  'scrollSnapPointsX',
  'scrollSnapPointsY',
  'scrollSnapType',
  'tabSize',
  'textDecoration',
  'textDecorationColor',
  'textDecorationLine',
  'textDecorationStyle',
  'textOrientation',
  'textSizeAdjust',
  'transform',
  'transition',
  'transformOrigin',
  'transformOriginX',
  'transformOriginY',
  'transformOriginZ',
  'transformStyle',
  'transitionProperty',
  'transitionDuration',
  'transitionTimingFunction',
  'transitionDelay',
  'userModify',
  'userSelect',
];
